import { useTranslation } from "next-i18next";
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from "next/router";

import { Heading } from "common/ui/Heading";
import { Paragraph } from "common/ui/Paragraph";
import { Stack } from "common/ui/Stack";
import { CreateListingLayout } from "components/CreateListingLayout";

export default function CreateListingConfirmationPage() {
  const { t } = useTranslation(["marketplace", "validation"]);
  const { query, push } = useRouter();

  return (
    <CreateListingLayout
      action={{
        text: t("createListingConfirmationPage.seeMyListing"),
        onClick: () => push({
          pathname: "/properties/[propertyId]",
          query: {
            propertyId: query.listingId,
            key: query.previewToken,
          },
        }),
      }
    }>
      <Stack direction="column" gap={24}>
        <Heading variant="h2">{t("createListingConfirmationPage.listingCreated")}</Heading>
        <Paragraph variant="p1">
          {t("createListingConfirmationPage.listingCreatedSuccessfully")}
        </Paragraph>
      </Stack>
    </CreateListingLayout>
  );
}

export const getStaticProps = async ({ locale }) => {
  return {
    props: {
      ...await serverSideTranslations(locale, [
        "marketplace",
        "common",
      ]),
    }
  }
}
